/** @module         Apollo */

import { gql }      from "@apollo/client";

const 

/** @name TEAM */

TEAM = gql`query

    fetchTeam (

        $after: String,

        $before: String,

        $first: Int,

        $last: Int

    ) { 
        
        adminContacts (

            first: $first

            last: $last

            before: $before

            after: $after

        ) {

            edges {

                node {

                    createdAt
      
                    email
                    
                    firstName
                    
                    id
                    
                    image
                    
                    lastName
                    
                    phone
                    
                    title
                    
                    updatedAt

                }
                    
            }

            pageInfo { 
            
                hasNextPage 
                
                hasPreviousPage 
                
                startCursor 
                
                endCursor 
            
            }

        } 
    
    }`,

/** @name POSTS_PREVIEW */

TEAM_PREVIEW = gql`query fetchTeamPreview ( $id: ID! ) {

    adminContact ( id: $id ) {

        createdAt
      
        email
        
        firstName
        
        lastName
        
        phone
        
        title
        
        updatedAt

    }

}`,

/** @name POST */

MEMBER = gql`query fetchMember (

    $id: ID!

) { adminContact ( id: $id ) {

    id

    createdAt
      
    email
    
    firstName
    
    lastName
    
    phone
    
    title

    image
    
    updatedAt

} }`,

/** @name LEGAL_DATA_LIST */

LEGAL_DATA_LIST = gql`query {

    adminLegalDataList {

      id

      legalEntityName

      registrationNumber

      countryCode

      legalAddress

      factualAddress

      phone

      servicePhone

      email

      bankAccounts {

        id

        iban

        bankName

        swiftCode

        isEnabled

        isDefault

      }

      createdAt

      updatedAt

    }

  }`,

/** @name LEGAL_DATA */

LEGAL_DATA = gql`query fetchLegalData (

    $id: ID!

) { adminLegalData ( id: $id ) {

    id

    legalEntityName

    registrationNumber

    countryCode

    legalAddress

    factualAddress

    phone

    servicePhone

    email

    bankAccounts {

      id

      iban

      bankName

      swiftCode

      isEnabled

      isDefault

    }

    createdAt

    updatedAt

} }`,

/** @name LEGAL_DATA (for invoice generation) */

LEGAL_DATA_FOR_INVOICE = gql`query LegalData($countryCode: String) {
    legalData(countryCode: $countryCode) {
        id
        legalEntityName
        registrationNumber
        countryCode
        legalAddress
        factualAddress
        phone
        servicePhone
        email
        bankAccounts {
            id
            iban
            bankName
            swiftCode
            isEnabled
            isDefault
        }
    }
}`,

/** @name WORKING_HOURS */

WORKING_HOURS = gql`query {
    workingOnDays {
        monday
        tuesday
        wednesday
        thursday
        friday
        saturday
        sunday
    }
}`;

/** @exports Queries */

export {

    TEAM,

    TEAM_PREVIEW,

    MEMBER,

    LEGAL_DATA_LIST,

    LEGAL_DATA,

    LEGAL_DATA_FOR_INVOICE,

    WORKING_HOURS

}